import { Component, OnInit } from "@angular/core";
import * as AOS from "aos";

@Component({
standalone: false,
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    //  this.autoScroll();\
    AOS.init({
      disable: "mobile",
    });
  }

  autoScroll() {
    const flavoursContainer = document.getElementById("flavoursContainer");
    const flavoursScrollWidth = flavoursContainer.scrollWidth;

    setInterval(() => {
      if (flavoursContainer.scrollLeft !== flavoursScrollWidth) {
        flavoursContainer.scrollTo(flavoursContainer.scrollLeft + 10, 5);
      }
    }, 1000);
  }
}
